import { render, staticRenderFns } from "./bookingsByPlacePage.vue?vue&type=template&id=9b5d545a&scoped=true&"
import script from "./bookingsByPlacePage.vue?vue&type=script&lang=ts&"
export * from "./bookingsByPlacePage.vue?vue&type=script&lang=ts&"
import style0 from "./bookingsByPlacePage.vue?vue&type=style&index=0&id=9b5d545a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5d545a",
  null
  
)

export default component.exports